class roMeasurementSave {
  //debugger;

  MeasurementID_GUID: string;
  OrderID_GUID: string;
  CustomerID_GUID: string;
  OrderDetailID_GUID: string;
  ProductItemID_GUID: string;
  MeasurementComments: string;
  MeasurementSettingsID_GUID: string;
  innerObj: string;

  roMeasurementSave() {
 //   debugger;
    this.MeasurementID_GUID = "";
    this.OrderID_GUID = "-1";
    this.CustomerID_GUID = "-1";
    this.OrderDetailID_GUID = "-1";
    this.ProductItemID_GUID = "-1";
    this.MeasurementComments = "-1";
    this.MeasurementSettingsID_GUID = "-1";
    this.innerObj = "-1";
  }
}

export default roMeasurementSave;
